var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('Tooltip',{attrs:{"isMarkdown":"","orientation":"bottom","text":_vm.tooltipMessage}},[_c('StatusBadge',{attrs:{"status":_vm.type,"text":_vm.text,"title":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }